module.exports = __webpack_public_path__ + "img/D2.930b8c06.jpg";